import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appDynamicSiderWidth]'
})
export class DynamicSiderWidthDirective {
  element: any = null;

  isResizingX = false;

  shiftPosition = { x: 0, y: 0 };
  @Output() mouseEnter = new EventEmitter<boolean>();

  constructor(private el: ElementRef) {
    this.element = this.el.nativeElement;
   }

   @HostListener('mouseenter')
   onMouseEnter() {
     this.mouseEnter.emit(true);
   }

   @HostListener('mouseleave')
   onMouseLeave() {
     this.mouseEnter.emit(false);
   }

  makesureInParent(position: any) {
    const parent: any = this.element.parentNode;
    if (position.x < 0) {
      position.x = 0;
    } else if (position.x > parent.clientWidth - this.element.clientWidth) {
      position.x = parent.clientWidth - this.element.clientWidth;
    }

    if (position.y < 0) {
      position.y = 0;
    } else if (position.y > parent.clientHeight - this.element.clientHeight) {
      position.y = parent.clientHeight - this.element.clientHeight;
    }

    return position;

  }

  // 改变宽度
  resizeElementX(ev: any) {
    const elementRect = this.element.getBoundingClientRect();
    const parentRect = this.element.parentNode.getBoundingClientRect();
    const min = this.element.parentNode.clientWidth / 10;
    let right = ev.clientX + this.shiftPosition.x;
    if (right - elementRect.left < min) {
      right = elementRect.left + min;
    } else if (right > parentRect.right) {
      right = parentRect.right;
    }
    const width = right - elementRect.left;
    this.element.style.width = Number(width * 100.0 / this.element.parentNode.clientWidth).toFixed(0) + '%';

  } 

  initResizing(ev: any) {
    const elementRect = this.element.getBoundingClientRect();
    this.shiftPosition.x = elementRect.right - ev.clientX;
  }

 

  setResizing(cursor: string, event: any) {
    if (cursor == null || cursor.indexOf('-resize') < 0) {
      this.isResizingX = false;
      return;
    }
    this.element.parentNode.parentNode.style = "user-select: none;";
    cursor = cursor.replace('-resize', '');
    this.isResizingX = cursor.indexOf('e') >= 0;
    this.initResizing(event);

  }

 

  getCursor(ev): string {
    const elementRect = this.element.getBoundingClientRect();
    const padding = 20;
    const pt = {
      x: ev.clientX,
      y: ev.clientY
    };
    let cursor = '';
    if (pt.x >= elementRect.left && pt.x <= elementRect.left + padding) {
    } else if (pt.x >= elementRect.right - padding && pt.x <= elementRect.right) {
      cursor += 'e';
    }
    if(cursor===""){
      return "";
    }
    return cursor + '-resize';
  }

 

  isParent(obj, parentObj) {
    while (obj !== undefined && obj != null && obj.tagName?.toUpperCase() !== 'BODY') {
      if (obj === parentObj) {
        return true;
      }
      obj = obj.parentNode;
    }
    return false;
  }

 

  @HostListener('document:mousedown', ['$event'])
  onMouseDown(ev: any) {
    if (this.isParent(ev.target, this.element)) {
      const cursor = this.getCursor(ev);
      this.setResizing(cursor, ev);
    }

  }

 

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(ev: any) {
    this.element.style.cursor = this.getCursor(ev);
    if (this.isResizingX) {
      this.resizeElementX(ev);
    }
  }

 

  @HostListener('document:mouseup', ['$event'])
  onMouseUp() {
    this.element.parentNode.parentNode.style = "user-select: text;";
    this.setResizing(null, null);
  }

}
